var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstDepth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 350,
    viewBox: "0 0 350 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_251_1264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.097 43.2495C186.097 43.2495 179.518 44.3057 179.518 50.8846C179.518 57.4635 186.097 57.9329 186.097 57.9329",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.643 70.8628V274.381H809.573C809.573 274.381 806.28 215.861 742.127 215.861C742.127 215.861 685.962 214.57 677.263 274.381V299.529H327.691H315.355",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.685 299.523V302.698L315.348 306.461H227.455V268.506C227.455 268.506 228.573 217.628 173.754 193.301C118.934 168.973 47.2013 213.044 47.2013 213.044L41.7339 222.033V244.945L45.7931 244.979L86.5021 245.297C86.5021 245.297 109.414 201.937 161.59 222.205C213.759 242.473 207.242 292.709 207.242 292.709C207.242 292.709 210.825 306.454 227.455 306.454",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6369 248.465H41.0363L24.9998 253.926V280.014H65.5362C65.5362 280.021 76.9061 261.685 76.6369 248.465Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7405 222.033C41.7405 222.033 44.4743 218.774 58.6606 217.801V236.481C58.6606 236.481 52.9309 241.327 41.7405 241.942",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.019 247.409C681.019 247.409 677.318 252.959 675.731 260.277H321.105V247.409H681.019Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.158 253.843H675.731",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.643 212.333H321.106V206.521H943.643",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.643 179.025H321.106V165.805H943.643",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.158 172.411H939.059",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.085 145.709H321.106V155.76H943.643",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.348 70.8628V306.454",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.025 306.454V70.8628",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.65 306.454V76.9724H243.553V306.454",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.897 85.0769H300.306V293.765H249.897V85.0769Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.569 70.8628H417.697V145.716H329.569V70.8628Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.262 73.7417H413.99V106.346H333.262V73.7417Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.262 110.93H413.99V142.83H333.262V110.93Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.085 66.7485H182.804",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.441 42.0759V61.64H190.411V42.0759",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.411 61.64L189.617 64.6361H186.09V40.426H190.204V42.069H192.434C196.838 32.7288 205.122 30.4368 205.122 30.4368C230.768 20.3925 317.751 19.3293 317.751 19.3293H931.659C947.64 36.0769 943.643 70.856 943.643 70.856H182.804V56.8698",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.756 73.7417L232.156 86.3748V153.116H188.913L199.959 79.0849H212.177V73.7417H218.756Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.272 150.735H228.863V87.079L215.525 73.7417",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.958 79.0847L197.494 76.9723H193.497L191.426 80.1409H188.092V70.8628",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.141 151.611H186.711V156.112",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.666 156.112H173.754V193.301C173.754 193.301 161.328 195.682 161.59 222.205",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.753 156.112C173.753 156.112 90.8165 165.715 61.208 177.264C61.208 177.264 47.4634 179.556 47.2011 213.044",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.125 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.365 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.604 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.837 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.077 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.316 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.549 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.789 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.029 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.261 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.501 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.741 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.974 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.213 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.453 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.686 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.925 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.165 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.159 349.89C104.039 349.89 77.1896 323.04 77.1896 289.92C77.1896 256.8 104.039 229.951 137.159 229.951C170.279 229.951 197.128 256.8 197.128 289.92C197.128 323.04 170.279 349.89 137.159 349.89Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.159 346.735C105.781 346.735 80.3445 321.298 80.3445 289.92C80.3445 258.542 105.781 233.105 137.159 233.105C168.537 233.105 193.974 258.542 193.974 289.92C193.974 321.298 168.537 346.735 137.159 346.735Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.159 323.76C118.469 323.76 103.319 308.61 103.319 289.92C103.319 271.231 118.469 256.08 137.159 256.08C155.848 256.08 170.999 271.231 170.999 289.92C170.999 308.61 155.848 323.76 137.159 323.76Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.159 322.242C119.308 322.242 104.837 307.771 104.837 289.92C104.837 272.069 119.308 257.599 137.159 257.599C155.01 257.599 169.48 272.069 169.48 289.92C169.48 307.771 155.01 322.242 137.159 322.242Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.159 300.938C131.074 300.938 126.141 296.005 126.141 289.92C126.141 283.835 131.074 278.902 137.159 278.902C143.244 278.902 148.177 283.835 148.177 289.92C148.177 296.005 143.244 300.938 137.159 300.938Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.159 303.029C129.918 303.029 124.049 297.16 124.049 289.92C124.049 282.68 129.918 276.811 137.159 276.811C144.399 276.811 150.268 282.68 150.268 289.92C150.268 297.16 144.399 303.029 137.159 303.029Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.793 248.466V244.972",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9655 277.563L76.644 292.177",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.242 292.709H197.135",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.414 138.586C190.195 139.367 190.195 140.633 189.414 141.414L176.686 154.142C175.905 154.923 174.639 154.923 173.858 154.142C173.077 153.361 173.077 152.095 173.858 151.314L185.172 140L173.858 128.686C173.077 127.905 173.077 126.639 173.858 125.858C174.639 125.077 175.905 125.077 176.686 125.858L189.414 138.586ZM26.0858 141.414C25.3047 140.633 25.3047 139.367 26.0858 138.586L38.8137 125.858C39.5948 125.077 40.8611 125.077 41.6421 125.858C42.4232 126.639 42.4232 127.905 41.6421 128.686L30.3284 140L41.6421 151.314C42.4232 152.095 42.4232 153.361 41.6421 154.142C40.8611 154.923 39.5948 154.923 38.8137 154.142L26.0858 141.414ZM188 142L27.5 142L27.5 138L188 138V142Z",
    fill: "#2D9DC9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 138,
    x2: 22,
    y2: 350,
    stroke: "#2D9DC9",
    strokeWidth: 4,
    strokeDasharray: "8 8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.687 132.975C191.86 131.884 192.895 131 194 131H216C217.105 131 217.86 131.884 217.687 132.975L215.497 146.803C215.324 147.894 214.289 148.778 213.184 148.778H191.184C190.08 148.778 189.324 147.894 189.497 146.803L191.687 132.975ZM201.918 147.471H202.867C203.103 147.471 203.325 147.282 203.361 147.05L203.909 143.595C203.945 143.362 203.784 143.174 203.548 143.174H202.599C202.363 143.174 202.141 143.362 202.104 143.595L201.557 147.05C201.52 147.282 201.682 147.471 201.918 147.471ZM204.587 136.611H203.638C203.402 136.611 203.24 136.422 203.278 136.185L203.825 132.73C203.862 132.497 204.083 132.309 204.32 132.309H205.268C205.505 132.309 205.666 132.497 205.629 132.73L205.082 136.189C205.045 136.422 204.823 136.611 204.587 136.611ZM196.189 140.781H199.695C199.931 140.781 200.152 140.592 200.189 140.359L200.337 139.424C200.374 139.192 200.212 139.003 199.976 139.003H196.47C196.234 139.003 196.013 139.192 195.976 139.424L195.828 140.359C195.791 140.592 195.952 140.781 196.189 140.781ZM206.85 140.355L206.998 139.42C207.035 139.187 207.256 138.999 207.493 138.999H210.999C211.235 138.999 211.397 139.187 211.36 139.42L211.212 140.355C211.175 140.588 210.953 140.776 210.717 140.776H207.211C206.975 140.776 206.813 140.588 206.85 140.355ZM197.021 144.921L197.588 145.583C197.731 145.75 198.003 145.75 198.194 145.583L201.063 143.138C201.259 142.972 201.301 142.704 201.157 142.541L200.59 141.879C200.447 141.712 200.175 141.712 199.984 141.879L197.115 144.324C196.924 144.486 196.882 144.754 197.021 144.921ZM207.207 137.902C207.016 138.068 206.744 138.068 206.601 137.902L206.034 137.239C205.89 137.076 205.932 136.809 206.128 136.642L208.997 134.197C209.188 134.03 209.46 134.03 209.603 134.197L210.171 134.86C210.314 135.022 210.272 135.29 210.076 135.457L207.207 137.902Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_251_1264"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 350,
    height: 350,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstDepth);
export default __webpack_public_path__ + "static/media/instDepth.f497f1fbbcbb58a86d2d91d7ebbaeea2.svg";
export { ForwardRef as ReactComponent };